import React from 'react';
import styled from 'styled-components';

const Container = styled.div<{
  background: string;
  disabled: boolean;
  fullWidth: boolean;
}>`
  background: ${(props) => props.background};
  opacity: ${(props) => (props.disabled ? '0.5' : '1')};
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  display: flex;
  cursor: pointer;
  width: 100%;
  transition: all 0.2s;
  / *box-shadow: 0px 3px 8px ${(props) => props.background || '#BBBAC3'}52; */
  box-shadow: 0px 3px 6px #0000001f; 
  &:hover {
    ${(props) => (props.disabled ? '' : `background: #00000021;`)}
  }
  ${(props) => (props.fullWidth ? 'width: 100%;' : '')}
`;

const ContainerNew = styled.div<{
  background: string;
  disabled: boolean;
  fullWidth: boolean;
  width?: string;
}>`
  background: ${(props) => (props.disabled ? '#ffffff00' : props.background)};
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  ${(props) => (props.width ? `width: ${props.width}` : '')};
  display: flex;
  cursor: pointer;
  transition: all 0.2s;
  /* box-shadow: 0px 3px 8px ${(props) => props.background || '#BBBAC3'}52; */
   box-shadow: 0px 3px 6px #0000001f; 
  ${(props) => (props.fullWidth ? 'width: 100%;' : '')}
`;

const Content = styled.div.attrs((props) => ({
  color: props.color || 'black',
}))`
  padding: 10px 34px;
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.color};
  letter-spacing: 1px;
`;

type Props = {
  children: React.ReactNode;
  background?: string;
  color?: string;
  disabled?: boolean;
  onClick?: () => void;
  fullWidth?: boolean;
  width?: string;
};
function Button({
  children,
  background = '#5c6ef8',
  color,
  disabled,
  onClick,
  fullWidth = false,
  width,
}: Props) {
  const onButtonClick = () => {
    if (!disabled && onClick) onClick();
  };
  return (
    <ContainerNew
      background={background}
      disabled={!!disabled}
      onClick={onButtonClick}
      fullWidth={fullWidth}
      width={width}
    >
      <Container
        background={background}
        disabled={!!disabled}
        fullWidth={fullWidth}
      >
        <Content color={color}>{children}</Content>
      </Container>
    </ContainerNew>
  );
}

export default Button;
